import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

/**
 * Registers the service worker and handles NAVIGATE messages from the SW
 * (push notification click -> in-app routing).
 *
 * Updates are automatic (registerType: 'autoUpdate') -- navigations use
 * NetworkFirst so online users always get fresh content; the SW update
 * just refreshes the offline cache silently.
 */
export default function UpdateBanner() {
  useRegisterSW()

  // Handle NAVIGATE messages from the SW (push notification click)
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return
    const handler = (event: MessageEvent) => {
      if (event.data?.type === 'NAVIGATE' && event.data?.url) {
        window.location.href = event.data.url as string
      }
    }
    navigator.serviceWorker.addEventListener('message', handler)
    return () => navigator.serviceWorker.removeEventListener('message', handler)
  }, [])

  return null
}
